import { hospitalServices } from '../services'

export const hospitalActions = {
    statusProntoSoccorso,
    hospitalNedocs,
}

function statusProntoSoccorso(idHospital, language, dispatch, intl) {
    dispatch(request());

    hospitalServices.getStatusProntoSoccorso(idHospital, language, intl)
        .then(
            res => {
                dispatch(success(res));
            },
            error => {
                dispatch(failure(error.message ? error.message : error));
            }
        );

    function request() { return { type: "STATUS_REQUEST" } }
    function success(status) { return { type: "STATUS_SUCCESS", status } }
    function failure(error) { return { type: "STATUS_FAILURE", error } }
}


function hospitalNedocs(idHospital, dispatch, intl) {
    dispatch(request());

    hospitalServices.getNedocs(idHospital, intl)
        .then(
            res=> {
                dispatch(success(res))
            },
            error=> {
                dispatch(failure(error))
            }
        );

    function request() { return { type: "NEDOCS_REQUEST" } }
    function success(nedocsStatus) { return { type: "NEDOCS_SUCCESS", nedocsStatus } }
    function failure(error) { return { type: "NEDOCS_FAILURE", error } }
}